import { AxiosResponse } from "axios";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";

/*
  Worker Saga: Fired on FETCH_ACCESSCONTROL_REQUEST action
*/
function* fetchPatternsSaga(action: types.FetchPatternsReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IExtractorPatterns[] | types.IApiError> = yield call(services.getPatterns, action.params);
        if (response.status === 200) {
            yield put(
                actions.fetchPatternsSuccess({
                    layerType: action.params.layerType,
                    patterns: response.data as types.IExtractorPatterns[],
                })
            );

        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
            yield put(actions.fetchPatternsFailure({ error: apiError })
            );
        }

    } catch (e: any) {
        yield put(
            actions.fetchPatternsFailure({
                error: e,
            })
        );
    }
}


/*
  Worker Saga: Fired on  action
*/
function* postCustomExtractorSaga(action: types.PostCustomExtRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        yield put(alert.enqueueSnackbar({ message: `Custom extractor in progress,Timestamp: ${timestamp}`, options: { variant: "success" } }));
        const response: AxiosResponse<types.ICustExtSuccess[] | types.IApiError> = yield call(services.postCustExtractor, action.payload);
        if (response.status === 200) {
            let dataPayload = response.data as types.ICustExtSuccess[];
            yield put(
                actions.postCustomExtSuccess({
                    customExtStatus: dataPayload
                })
            );
            if (dataPayload[0].isSuccess && dataPayload[0].layerType !== "EXTRACT_ADLS") {
                yield put(alert.enqueueSnackbar({ message: `Custom extractor created successfully. Batch Code: ${dataPayload[0].batchCode}, Timestamp: ${timestamp}`, options: { variant: "success" } }));
            }
            else if (dataPayload[0].isSuccess && dataPayload[0].layerType === "EXTRACT_ADLS") {
                yield put(alert.enqueueSnackbar({ message: `Custom extractor created successfully. Batch Code: ${dataPayload[0].batchCode}, Timestamp: ${timestamp}`, options: { variant: "success" } }));
                yield put(alert.enqueueSnackbar({ message: `Ensure you create folders and upload csv file under the path ${dataPayload[0].extSchema}, Timestamp: ${timestamp}`, options: { variant: "success" } }));
            }
            else yield put(
                alert.enqueueSnackbar({
                    message: `${dataPayload[0].errorMessage}. Timestamp: ${timestamp}`,
                    options: { variant: "error" },
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
            yield put(
                actions.postCustomExtFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postCustomExtFailure({
                error: e.message,
            })
        );
    }
}

function* postDBExtractorSaga(action: types.PostDBExtRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        yield put(alert.enqueueSnackbar({ message: `DB extractor for ${action.payload.entities[0].name} in progress, Timestamp: ${timestamp}`, options: { variant: "success" } }));
        const response: AxiosResponse<types.IDBExtSuccess[] | types.IApiError> = yield call(services.postMetaDataDBExtractor, action.payload);

        if (response.status === 200) {
            let dataPayload = response.data as types.IDBExtSuccess[];
            yield put(
                actions.postDBExtSuccess({
                    dbExtStatus: dataPayload
                })
            );
            if (dataPayload[0].isSuccess === true) yield put(alert.enqueueSnackbar({ message: `DB extractor for ${action.payload.entities[0].name} created successfully. Batch Code: ${dataPayload[0].batchCode}, Timestamp: ${timestamp}`, options: { variant: "success" } }));
            else yield put(
                alert.enqueueSnackbar({
                    message: `${dataPayload[0].errorMessage}. Timestamp: ${timestamp}`,
                    options: { variant: "error" },
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
            yield put(
                actions.postDBExtFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postDBExtFailure({
                error: e.message,
            })
        );
    }
}

function* fetchExtractorListSaga(action: types.FetchExtractorListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IDataExtractorList | types.IApiError> = yield call(services.getDataExtractorList, action.params);
        if (response.status === 200) {
            yield put(
                actions.fetchExtractorListSuccess({
                    extractors: response.data as types.IDataExtractorList,
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }
    } catch (e: any) {
        yield put(
            actions.fetchExtractorListFailure({
                error: e,
            })
        );
    }
}

function* fetchExtractorDetailSaga(action: types.FetchExtractorDetailReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.ISingleExtractorDetail | types.IApiError> = yield call(services.getExtractorDetail, action.params);
        if (response.status === 200) {
            yield put(
                actions.fetchExtractorDetailSuccess({
                    extractorDetail: response.data as types.ISingleExtractorDetail,
                })
            );

        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
            yield put(actions.fetchExtractorDetailFailure({ error: apiError })
            );
        }

    } catch (e: any) {
        yield put(
            actions.fetchExtractorDetailFailure({
                error: e,
            })
        );
    }
}

function* deleteExtractorSaga(action: types.DeleteExtractorRequest) {
    const timestamp = new Date().toLocaleString();

    try {
        const response: AxiosResponse<types.IDeleteExtractorSuccess[] | types.IApiError> = yield call(services.deleteExtractor, action.payload);
        if (response.status === 200) {
            let dataPayload = response.data as types.IDeleteExtractorSuccess[];
            yield put(
                actions.deleteExtractorSuccess({
                    deleteStatus: dataPayload
                })
            );
            if (dataPayload[0].isDeleted === true) yield put(alert.enqueueSnackbar({ message: `The extractor ${dataPayload[0].batchCode} was successfully deleted, Timestamp: ${timestamp}.`, options: { variant: "success" } }))
            else yield put(alert.enqueueSnackbar({ message: `The extractor could not be deleted. Timestamp: ${timestamp}`, options: { variant: "error" } }));

        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }

    } catch (e: any) {
        yield put(
            actions.deleteExtractorFailure({
                error: e,
            })
        );
    }
}

function* putExtractorSaga({ batchCode, payload }: types.PutExtractorRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPutExtractorSuccess | types.IApiError> = yield call(services.editExtractor, batchCode, payload);

        if (response.status === 200) {
            let dataPayload = response.data as types.IPutExtractorSuccess;
            yield put(
                actions.putExtractorSuccess({
                    extractor: dataPayload,
                })
            );
            let successMsg = `The extractor was successfully edited. Extractor ID: ${batchCode}, Timestamp: ${timestamp}.`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}.`;
            yield put(
                actions.putExtractorFailure({
                    error: apiError,
                })
            );
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

        }
    } catch (e: any) {
        yield put(
            actions.putExtractorFailure({
                error: e,
            })
        );
    }
}

function* postSchemaExtSaga({ batchCode, payload }: types.PostSchemaExtRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPostExtractorSchemaSuccess | types.IApiError> = yield call(services.editSchemaExt, batchCode, payload);

        if (response.status === 204) {
            let dataPayload = response.data as types.IPostExtractorSchemaSuccess;
            yield put(
                actions.postSchemaExtSuccess({
                    extractor: dataPayload,
                })
            );
            let successMsg = `The Schema was successfully edited. Extractor ID: ${batchCode}, Timestamp: ${timestamp}.`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}.`;
            yield put(
                actions.postSchemaExtFailure({
                    error: apiError,
                })
            );
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

        }
    } catch (e: any) {
        yield put(
            actions.postSchemaExtFailure({
                error: e,
            })
        );
    }
}

function* postRetrySchemaUpdateSaga({ batchCode, forceValue }: types.PostRetrySchemaUpdateRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPostRetrySchemaUpdateSuccess | types.IApiError> = yield call(services.retrySchemaUpdate, batchCode, forceValue);

        if (response.status === 204) {
            let dataPayload = response.data as types.IPostRetrySchemaUpdateSuccess;
            yield put(
                actions.postRetrySchemaUpdateSuccess({
                    extractor: dataPayload,
                })
            );
            let successMsg = `The Schema was successfully updated. Extractor ID: ${batchCode}, Timestamp: ${timestamp}.`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}.`;
            yield put(
                actions.postRetrySchemaUpdateFailure({
                    error: apiError,
                })
            );
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

        }
    } catch (e: any) {
        yield put(
            actions.postRetrySchemaUpdateFailure({
                error: e,
            })
        );
    }
}


function* fetchExtractorStatusSaga(action: types.FetchExtractorStatusReq) {

    try {
        const response: AxiosResponse<types.ISingleExtractorStatus[]> = yield call(services.getExtractorStatus, action.params);
        yield put(
            actions.fetchExtractorStatusSuccess({
                extractorStatus: response.data as types.ISingleExtractorStatus[]
            })
        );
    } catch (e: any) {
        yield put(
            actions.fetchExtractorListFailure({
                error: e,
            })
        );
    }
}

/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
  Allows concurrent increments.
*/

function* getPatternsSaga() {
    yield takeEvery(actionTypes.FETCH_PATTERNS_REQUEST, fetchPatternsSaga);
}

function* postCustExtSaga() {
    yield takeEvery(actionTypes.POST_CUSTOMEXT_REQUEST, postCustomExtractorSaga);
}

function* metaDataPostDBExtSaga() {
    yield takeEvery(actionTypes.POST_DBEXT_REQUEST, postDBExtractorSaga);
}

function* extractorListSaga() {
    yield takeLatest(actionTypes.FETCH_EXTRACTOR_LIST_REQUEST, fetchExtractorListSaga);
}

function* getExtractorDetailSaga() {
    yield takeEvery(actionTypes.FETCH_EXTRACTOR_DETAIL_REQUEST, fetchExtractorDetailSaga);
}

function* getExtractorStatusSaga() {
    yield takeEvery(actionTypes.FETCH_EXTRACTOR_STATUS_REQUEST, fetchExtractorStatusSaga);
}

function* getDeleteExtractorSaga() {
    yield takeEvery(actionTypes.DELETE_EXTRACTOR_REQUEST, deleteExtractorSaga);
}

function* editExtractorSaga() {
    yield takeEvery(actionTypes.PUT_EXTRACTOR_REQUEST, putExtractorSaga);
}

function* editSchemaExtSaga() {
    yield takeEvery(actionTypes.POST_EXTRACTORSCHEMA_REQUEST, postSchemaExtSaga);
}

function* retrySchemaUpdateSaga() {
    yield takeEvery(actionTypes.POST_RETRYSCHEMAUPDATE_REQUEST, postRetrySchemaUpdateSaga);
}

function* patternsSaga() {
    yield all([
        getPatternsSaga(),
        postCustExtSaga(),
        extractorListSaga(),
        getDeleteExtractorSaga(),
        editExtractorSaga(),
        getExtractorDetailSaga(),
        getExtractorStatusSaga(),
        metaDataPostDBExtSaga(),
        editSchemaExtSaga(),
        retrySchemaUpdateSaga()
    ])
}

export default patternsSaga;